import SidePanel from "../../../components/SidePanel";
import React from "react";
import useMap from "../../../components/useMap";
import FiltersPanel from "./FiltersPanel";
import MDBox from "../../../materialDashboard/components/MDBox";
import Stack from "@mui/material/Stack";
import {useTranslation} from "react-i18next";
import useWebgis from "./useWebgis";
import WebgisMap from "./WebgisMap";
import DataPanel from "./Panels";


const WebGis = () => {
    const {t} = useTranslation(["webgis"]);
    const webgis = useWebgis();

    const {layersState, featuresState, filterPanel} = webgis;
    const {mapRef, mapBoxRef} = useMap();

    return <Stack direction="row"
                  spacing={{xs: 0, lg: 1}}
                  sx={{width: "100%", height: "calc(100vh - 110px)", position: "relative"}}>
        <SidePanel open={filterPanel.isOpen}
                   onClose={filterPanel.close}
                   title={t("filtersTitle")}
                   width="20vw"
                   sx={{px: 0}}>
            <FiltersPanel layersState={layersState} featuresState={featuresState} />
        </SidePanel>

        <MDBox ref={mapBoxRef}
               borderRadius="xl"
               bgColor="grey-300"
               sx={{
                   width: "100%",
                   height: "100%",
                   scrollMarginTop: 100,
                   overflow: "hidden",
                   boxShadow: 1,
                   position: "relative",
                   zIndex: 2,
               }}>
            <WebgisMap mapRef={mapRef}  webgis={webgis} />
        </MDBox>

        <DataPanel webgis={webgis} />
    </Stack>
}

export default WebGis;